// extracted by mini-css-extract-plugin
export default {"mapPin":"MapPin_mapPin__uQsar"};